import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: import.meta.env.VITE_KEYCLOAK_URL,
  realm: import.meta.env.VITE_KEYCLOAK_REALM,
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
});

export function initializeKeycloak(): Promise<boolean> {
  return new Promise((resolve, reject) => {
    keycloak
      .init({
        onLoad: 'login-required',
        checkLoginIframe: false,
        pkceMethod: 'S256',
      })
      .then((authenticated: boolean) => {
        if (authenticated) {
          resolve(true);
        } else {
          reject('Not authenticated');
        }
      })
      .catch(() => {
        reject('Keycloak init error');
      });
  });
}

export const getKeycloak = () => keycloak;
